import { cn } from "@/lib/utils";
import { stageColor, stageLabel } from "./pipeline/useOfferStages";

/** Celda de estatus a color, como en Monday. */
export const StagePill = ({
  stage,
  className,
}: {
  stage: string;
  className?: string;
}) => {
  const [color, dark] = stageColor(stage);
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-md px-2.5 py-0.5 text-xs font-bold whitespace-nowrap",
        dark ? "text-[#1B2130]" : "text-white",
        className,
      )}
      style={{ background: `var(${color})` }}
    >
      {stageLabel(stage)}
    </span>
  );
};

/** Cuadrito de color del producto. */
export const OfferDot = ({ color }: { color: string }) => (
  <span
    className="inline-block size-2.5 rounded-[3px] shrink-0"
    style={{ background: color }}
  />
);
